import React, {useEffect, useRef} from 'react';
import styled from "styled-components";
import {motion, AnimatePresence} from "framer-motion";
import FocusTrap from "focus-trap-react";
import exit from "../images/exit.svg";
import { chooseLang } from "./chooseLang";

const Overlay = styled(motion.div)`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
    z-index: 199;
`;
const ModalContainer = styled(motion.div)`
    width: 50%;
    background-color: white;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 12px;
    padding: 25px;
    max-width: 670px;

    @media (max-width: 1200px) {
        width: auto;
    }

    @media (max-width: 780px) {
        width: 100%;
        height: 70%;
        bottom: 0;
        left: 0;
        transform: none;
        box-sizing: border-box;
        max-width: none;
    }

    .exit_popup {
        position: absolute;
        right: 36px;
        top: 21px;
        cursor: pointer;

        img {
            width: 25px;
        }
    }
`;
const CloseButton = styled.svg`
    width: 20px;
    height: 20px;
    position: absolute;
    right: 18px;
    top: 18px;
    cursor: pointer;
`;

const modalVariant = {
    initial: {opacity: 0},
    isOpen: {opacity: 1},
    exit: {opacity: 0}
};
const containerVariant = {
    initial: {top: "-50%", transition: {type: "spring"}},
    isOpen: {top: "50%"},
    exit: {top: "-50%"}
};

const Modal2 = ({handleClose, children, isOpen, ariaTitle, role, lang, onCloseHandle}) => {
    const closeButtonRef = useRef(null);

    useEffect(() => {
        if (closeButtonRef.current) {
            closeButtonRef.current.focus();
        }
    }, [closeButtonRef.current]);

    const langData = chooseLang(lang);

    return (
        <AnimatePresence>
            {isOpen && (
                <Overlay
                    initial={"initial"}
                    animate={"isOpen"}
                    exit={"exit"}
                    variants={modalVariant}
                >

                    <ModalContainer
                        onKeyDown={(e) => {
                            if (e.key === "Escape") {
                                handleClose(e, true);
                            }
                        }}
                        aria-modal="true"
                        aria-label={ariaTitle}
                        tabIndex={0}
                        role={role || "dialog"}
                        variants={containerVariant}>
                        <FocusTrap>
                            <div>
                                <div
                                    role='button'
                                    aria-label={langData.arias.close}
                                    tabIndex={"0"}
                                    ref={closeButtonRef}
                                    onKeyDown={(e) => {
                                        if (e.key === " " || e.key === "Enter") {
                                            handleClose(e, true);
                                        }
                                    }}
                                    className="exit_popup"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleClose(e, true);
                                    }}
                                >
                                    <img src={exit} alt="exit"/>
                                </div>
                                {children}
                            </div>
                        </FocusTrap>
                    </ModalContainer>
                </Overlay>
            )}
        </AnimatePresence>
    );
};

export default Modal2;
